<template>
    <div class="donate-cta">
        <h2 class="donate-heading">Every animal deserves a loving home.</h2>
    <h2 class="donate-title">Please join us in supporting the Berrien County Animal Control</h2>
   <p class="donate-description">
        Your donation helps provide food, shelter, and medical care for animals in need. Join us in making a difference!
      </p>
      <div class="donate-section">
        <div class="donate-image">
          <img src="@/assets/optimized/JDawg-500.webp" alt="Doggo" width="250" height="260" loading="lazy" decoding="async" style="width: 250px; height: auto;" />
        </div>

        <a href="https://www.berriencounty.org/224/Donate" 
        target="_blank" 
        rel="noopener noreferrer"
        class="donate-button"> Donate Now</a>

      <a href="https://www.berriencounty.org/FormCenter/Animal-Control-Encrypted-31/Volunteer-Application-196" 
            target="_blank" 
            rel="noopener noreferrer"
            class="volunteer-button">
            Volunteer </a>
    </div>
        
      


    </div>
  </template>
  
  <script>
  export default {
    name: "DonateCTA",
  };
  </script>
  
  <style scoped>
  .donate-cta {
    background: transparent;
    text-align: center;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  .donate-heading{
    font-size: 2.5em;
    color: #fff;
    margin-bottom: 20px;
    text-shadow: 2px 2px 0px #000000;
    letter-spacing: 2px;
  }
  .donate-title {
    font-size: 1.8em;
    color: #fff;
    margin-bottom: 10px;
  }
  
  .donate-description {
    font-size: 1.2em;
    color: #fff;
    margin-bottom: 20px;
  }
  
  .donate-button,
  .volunteer-button {
    display: inline-block;
    margin: 10px 5px;
    padding: 11px 24px;
    border: 2px solid rgba(255, 255, 255, 0.35);
    border-radius: 10px;
    background: linear-gradient(135deg, #1656a8 0%, #2b7de5 60%, #69aef8 100%);
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.34), 0 0 0 1px rgba(255, 255, 255, 0.08) inset;
    color: #fff;
    font-size: 1em;
    font-weight: 600;
    text-decoration: none;
    transition: transform 0.22s ease, box-shadow 0.22s ease, filter 0.22s ease;
  }

  .donate-button:hover,
  .volunteer-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.32), 0 0 0 1px rgba(255, 255, 255, 0.1) inset;
    filter: brightness(1.05);
  }

  .donate-button:focus-visible,
  .volunteer-button:focus-visible {
    outline: 3px solid #f1c40f;
    outline-offset: 2px;
  }
  </style>